export const NEBA = 'NEBA'
export const VULA = 'VULA'
export const FTTH = 'FTTH'
export const ADSL = 'ADSL'
export const MASMOVIL = 'MASMOVIL'
